<template>
  <div class="container">
    <h1>Authorization successful</h1>
    <p>{{ getMessage }}</p>
    <div id="suggestions">
      <a @click="closeWindow">
        Close this window or it will be automatically close after
        {{ remainingTime }} sec.
      </a>
    </div>
  </div>
</template>
<script>
import { setCookie } from '@/helpers/cookie';
export default {
  data() {
    return {
      remainingTime: 3
    };
  },
  mounted() {
    setCookie('ssoAuthWindow', true);
    this.autoCloseWindow();
  },
  computed: {
    getMessage() {
      return this.$message?.SSO_CALLBACK_MESSAGE?.[this.$route.query.type]
        ?.success;
    }
  },
  methods: {
    closeWindow(e) {
      e.preventDefault();
      window.close();
    },
    autoCloseWindow() {
      setInterval(() => {
        if (this.remainingTime > 1) {
          this.remainingTime--;
        } else {
          window.close();
        }
        // eslint-disable-next-line
      }, 1000);
    }
  }
};
</script>
<style>
.container {
  margin: 50px auto 40px auto;
  text-align: center;
}
a {
  color: #4183c4;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
h1 {
  letter-spacing: -1px;
  line-height: 160px;
  font-size: 8.4vw;
  font-weight: 100;
  margin: 0px;
  text-shadow: 0 1px 0 #fff;
}
p {
  color: rgba(0, 0, 0, 0.5);
  margin: 10px 0 10px;
  font-size: 18px;
  font-weight: 200;
  line-height: 1.6em;
}
ul {
  list-style: none;
  margin: 25px 0;
  padding: 0;
}
li {
  display: table-cell;
  font-weight: bold;
  width: 1%;
}
h1.smaller {
  letter-spacing: 0px;
  font-size: 32px;
}
.step-list li {
  text-align: left;
  font-weight: normal;
  display: list-item;
  width: auto;
  line-height: 25px;
}
#suggestions {
  margin-top: 35px;
  color: #ccc;
}
#suggestions a {
  color: #666666;
  font-weight: 200;
  font-size: 14px;
  margin: 0 10px;
}
</style>
